/* eslint-disable no-console */
import { checkAvailability } from '../dealer-availability/dealer-lookup-form';
import { updateEmalSignupForm } from '../dealer-availability/email-signup-form';
import DealerAvailabilityModal from '../dealer-availability-modal';
import { sendContactDealerLeadToDrip } from '../drip-helpers';
import { addVisualizationSceneFormGroup } from './share-visualization-scenes';
import { removeAllErrors, validate } from '../../utils/form-validation-utils';

const setScrollToDealerContactForm = () => {
  const headerOffset = 108;
  const formWrapper = document.querySelector('.dealer-contact-form-wrapper');
  const y = formWrapper.offsetTop - headerOffset;
  window.scrollTo({
    top: y,
    behavior: 'smooth',
  });
};

const submitDealerContactForm = (form) => {
  const formError = form.querySelector('.form-error-message');
  const confirmationDiv = document.querySelector('.form-submit-confirmation');
  removeAllErrors(form);
  formError.classList.add('hidden');
  if (validate(form)) {
    // Check dealer availability
    const { dealerAvailabilityCheckRadius } = window;
    checkAvailability({
      address: form.querySelector('#Zip').value,
      radius: dealerAvailabilityCheckRadius,
      onDealerAvailable: () => {
        sendContactDealerLeadToDrip(form, {
          success: () => {
            form.classList.add('hidden');
            confirmationDiv.classList.remove('hidden');
            if (document.querySelector('.dealer-contact-modal')) {
              return;
            }
            setScrollToDealerContactForm();
          },
          fail: (data) => {
            console.log(data);
            formError.classList.remove('hidden');
          },
        });
      },
      onDealerNotAvailable: () => {
        // Pass email address to email signup form
        const email = form.querySelector('#Email').value;
        updateEmalSignupForm({ email });
        DealerAvailabilityModal({
          state: 'dealer-not-available',
        });
      },
    });
  }
};

const initDealerContactForm = () => {
  const form = document.querySelector('.dealer-contact-form');
  const contactBtn = form.querySelector('.submit-btn');
  // Check logged-in status, saved visualization scenes
  const { isVisualizerActive } = window;
  if (isVisualizerActive) {
    addVisualizationSceneFormGroup(form);
  }
  // Add submit event handler
  contactBtn.addEventListener('click', (event) => {
    event.preventDefault();
    submitDealerContactForm(form);
  });
};

export default initDealerContactForm;
/* eslint-enable no-console */
